module.exports = __webpack_public_path__ + "media/images/campaign_banner-fdc57ab8510b9db981324e9590355de2.png";